<template>
    <div class="wrapper-form-block-enderecoEmpresarial" :inert="pPreview">
        <TrfFormularioBaseEnderecoFormulario
        @update:form-data="(formData) => setEndereco(formData)"
        id="form-block-empresa-endereco"
        ref="BlockEmpresaEndereco"
        :required="required"
        :pIsDirty="pIsDirty"
        :pPreview="pPreview"
        :formData="formData"
        @set:validacao="setValidacao"
        @is:mounted="inicializarCampos"
      >
        <template #titulo>
          <p><strong>Qual o endereço da empresa?</strong></p>
        </template>
      </TrfFormularioBaseEnderecoFormulario>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  export default {
    name: 'TrfBlocoEnderecoEmpresarial',
    emits: ['update:form-data', 'set:validacao'],
    components: {
      TrfFormularioBaseEnderecoFormulario: defineAsyncComponent(() => import('../../FormularioBaseEndereco/FormularioBaseEnderecoFormulario.vue'))
    },
    props: {
        pEnderecoFormData: {
            type: Object,
            default: () => {}
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        required: {
          type: Boolean,
          default: false
        },
        pEmpresa: {
          type:Object,
          default: () => {}
        },
        pIsDirty: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        formData: {
            endereco: this.pEmpresa?.endereco? {...this.pEmpresa.endereco} : this.pEnderecoFormData
        },
        isDirty: this.pIsDirty,
        isCampoInicializado: false
      };
    },
    methods: {
        async inicializarCampos() {
          if (!this.$refs.BlockEmpresaEndereco) return;
          this.$refs.BlockEmpresaEndereco.inicializarCampos(this.pEmpresa?.endereco);
          await this.$nextTick();
          this.isDirty = true;
          this.isCampoInicializado = true;
          this.emitFormData();
        },
        setValidacao(validacao) {
          this.$emit('set:validacao', validacao)
        },
        setEndereco(formData) {
            this.formData.endereco = formData;
            this.emitFormData(this.formData);
            this.isDirty = true;
        },
        emitFormData(value = this.formData) {
            if (!this.isCampoInicializado) return;
            this.$emit('update:form-data', value)
        }
    }
  };
  </script>
  